<obg-m-dialog-layout
	test-id="dialog-layout-modal"
	#dialog
	[titleText]="'account-details.annual-data-validation.confirm-details' | translate"
	[hideFooter]="false"
	[hideClose]="false"
	[navbar]="true"
	[navbarOptions]="navbarOptions"
	[ngStyle]="!shouldShow ? { 'display': 'none' } : null"
>
	<account-annual_data_validation_alert
		(updateDataClick)="openEditDialog()"
		(customerUpdated)="handleCustomerUpdateOutcome($event.detail)"
		(openFacialRecognition)="openFacialRecognition()"
		(currentCustomer)="updateCustomer($event.detail)"
		[isLoading]="loadingSpinner"
	/>
</obg-m-dialog-layout>
